import {
  FaFacebook,
  // FaHome,
  FaInstagram,
  FaLink,
  // FaLinkedin,
  FaMailBulk,
  // FaPhone,
  FaWhatsapp,
  // FaTwitter,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./footerStyles.css";
import React from "react";
import { motion } from "framer-motion";

const footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left">
          <div className="location">
            <FaLink size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            {/* <div>
              <p>Based In DOUALA</p>
              <p>Cameroon</p>
              <p>CONTACT</p>
            </div> */}
            <div className="fnav">
            <ul>
        <li>
          <Link to="/">
            <h1>Home</h1>
          </Link>
        </li>
        <li>
          <Link to="/Project">
            <h1>Project</h1>
          </Link>
        </li>
        <li>
          <Link to="/About">
            <h1>About</h1>
          </Link>
        </li>
        <li>
          <Link to="/Contact">
            <h1>Contact</h1>
          </Link>
        </li>
      </ul>
            </div>
          </div>
          {/* <div className="phone">
            <h4>
              <a href="tel:+237676648875">
                <FaPhone
                  size={20}
                  style={{ color: "#fff", marginRight: "2rem" }}
                />
                0676648875
              </a>
            </h4>
          </div> */}
          <div className="email">
            <h4>
              {/* <a href="mailto:vxy@virxee.onmicrosoft.com"> */}
              <a href="mailto:virxee@duck.com">
                <FaMailBulk
                  size={20}
                  style={{ color: "#fff", marginRight: "2rem" }}
                />
                virxee@duck.com
              </a>{" "}
            </h4>
          </div>
        </div>

        {/* <div className="mid">
        <ul className="fnav">
        <li>
          <Link to="/">
            <h1>Home</h1>
          </Link>
        </li>
        <li>
          <Link to="/Project">
            <h1>Project</h1>
          </Link>
        </li>
        <li>
          <Link to="/About">
            <h1>About</h1>
          </Link>
        </li>
        <li>
          <Link to="/Contact">
            <h1>Contact</h1>
          </Link>
        </li>
      </ul>
        </div> */}

        <div className="right">
          <h4>About the Company</h4>
          <p>
            This is Ngangmi Millenian. Founder of Virxee agency. We enjoy
            discussing new projects and design challenges. 
            Our Clients satisfaction is 100% guaranteed.
          </p>
          <div className="social">
            {/*<a
              target="_blank" rel="noreferrer"
              href="https://www.linkedin.com/in/ngangmi-millen"
            >
               <FaLinkedin
                size={20}
                style={{ color: "skyblue", marginRight: "2rem" }}
              /> 
            </a>*/}
           {/* <a target="_blank" rel="noreferrer"
              href="https://twitter.com/ngangmir">
               <FaTwitter
                size={20}
                style={{
                  color: "#0084ff",
                  "&:hover": { color: "skyblue" },
                  marginRight: "2rem",
                }}
              /> 
            </a>*/}
            <motion.a target="_blank" rel="noreferrer"
              href="https://instagram.com/virxee">
              <FaInstagram
                size={20}
                style={{ color: "#ff217e", marginRight: "2rem" }}
              />
            </motion.a>
            <a target="_blank" rel="noreferrer"
              href="https://facebook.com/virxee">
              <FaFacebook
                size={20}
                style={{ color: "#0032e8", marginRight: "2rem" }}
              />
            </a>
            <a
              target="_blank" rel="noreferrer"
              href="https://wa.me/237676648875?text=Hello I am here for"
            >
               <FaWhatsapp
                size={20}
                style={{ color: "green", marginRight: "2rem" }}
              /> 
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default footer;
